import { render, staticRenderFns } from "./rolesSettings.vue?vue&type=template&id=445d4ffa&scoped=true"
import script from "./rolesSettings.vue?vue&type=script&lang=js"
export * from "./rolesSettings.vue?vue&type=script&lang=js"
import style0 from "./rolesSettings.vue?vue&type=style&index=0&id=445d4ffa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445d4ffa",
  null
  
)

export default component.exports